import type { RootState } from '@/store';

import { midleNestApi as api, ProfilePrivateDto } from '@/store/services/MidleNestApi.service';
import { createSelector, createSlice } from '@reduxjs/toolkit';

interface ProfileState {
  profile?: ProfilePrivateDto | null;
  guild?: any | null;
  notificationsCount?: number | null;
}

const initialState: ProfileState = {
  profile: null,
  guild: null,
  notificationsCount: 0,
};

const slice = createSlice({
  name: 'profile',
  initialState,
  reducers: {},
  extraReducers: (builder) =>
    builder.addMatcher(api.endpoints.homeControllerGetSelf.matchFulfilled, (state, { payload }) => {
      state.profile = payload?.profile;
      state.notificationsCount = 0;
    }),
});

const profileActions = slice.actions;
export const profileReducer = slice.reducer;

const ProfileState = (state: RootState): typeof initialState => state.profile;

const selectUserProfile = createSelector(ProfileState, (state) => state.profile);

export { profileActions, selectUserProfile };
